import { createPortal } from 'react-dom';
import style from './LoaderBase.module.scss';

const LoaderBase = () => {
  return createPortal(
    <div className={style.loader}>
      <span></span>
    </div>,
    document.body
  );
};

export default LoaderBase;
